var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScholarship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.16,145,56.41,126.89V103.1s-1.22-6.1-6.72-5.8-7,4-7,6.1v32.34l23.49,27.15.3,30.5H94.23V155.57s1.74-5.68-7.62-15.87c-7.9-8.58-22.51-28.77-30.14-19.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.88,145l16.75-18.14V103.1s1.22-6.1,6.71-5.8,7,4,7,6.1v32.34l-23.49,27.15-.3,30.5H120.81V155.57s-1.75-5.68,7.62-15.87c7.9-8.58,22.51-28.77,30.13-19.31"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 107.37,
    cy: 49.87,
    rx: 42.14,
    ry: 26.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.62,58.07a17.77,17.77,0,0,1,1.89,7.9c0,14.68-18.86,26.58-42.14,26.58S65.23,80.65,65.23,66a17.69,17.69,0,0,1,1.9-7.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.62,74.18a17.74,17.74,0,0,1,1.89,7.9c0,14.67-18.86,26.57-42.14,26.57S65.23,96.75,65.23,82.08a17.66,17.66,0,0,1,1.9-7.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.47,41.62s-10.89-4.57-11.94,2.11c-1.34,8.48,11.7,3.39,12.17,10.77s-9.83,5.62-12.52,2.81"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.53,
    y1: 33.07,
    x2: 107.53,
    y2: 39.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.53,
    y1: 59.89,
    x2: 107.53,
    y2: 65.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholarship);
export default __webpack_public_path__ + "static/media/SCHOLARSHIP.3a8668a7fcebfe3d3ee0e64bcb5393a8.svg";
export { ForwardRef as ReactComponent };